var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mt-md-5 text-center"},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(new Date().getFullYear() - 1)+" - "+_vm._s(new Date().getFullYear())+" © Sellerdesk.ai ")])])}
var staticRenderFns = []

export { render, staticRenderFns }